import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { MatSnackBar } from '@angular/material/snack-bar';

import { AuthenticationService } from '@app/services/authentication.service';

@Injectable({ providedIn: 'root' })
export class AuthGuard implements CanActivate {
    constructor(
        private router: Router,
        private authenticationService: AuthenticationService,
        private _snackBar: MatSnackBar
    ) { }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        const currentUser = this.authenticationService.currentUserValue;
        const expectedPerm = route.data.expectedPermission;

        if (currentUser) {            
            if (expectedPerm) {
                // Verifica si tiene Full Access primero
                const check_full = obj => obj.permission === 'full';
                if (currentUser.perms.some(check_full)) {
                    return true;
                }

                // Si no tiene Full Access, verifica si tiene permiso requerido
                const check = obj => obj.permission === expectedPerm;
                if (currentUser.perms.some(check) ) {
                    const perm = currentUser.perms.find(({ permission }) => permission === expectedPerm)
                    if (perm.access_type != "0") {
                        return true;
                    }
                }

                this.openSnackBar('No tiene acceso a esta sección.' );
                return false;
                
            } else {
                return true;
            }
        } else {
            // not logged in so redirect to login page with the return url
            this.router.navigate(['/login'], { queryParams: { returnUrl: state.url } });
        }

        return false;
    }

    openSnackBar(message: string) {
        this._snackBar.open(message,"", {
           duration: 2000
        });
      }  
    
}